import { Component, OnInit, Input, Output, Inject, EventEmitter, OnChanges, transition, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroupDirective, ControlContainer, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { ISample, Sample } from '../../models/ISample';
import { ISampleCategory } from '../../models/ISampleCategory';
import { ICountry } from '../../models/ICountry';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CategoryPickerComponent } from '../category-picker/category-picker.component';
import { S1DataService } from '../../services/s1data.service';
import { Observable } from 'rxjs/Observable';
import { IResearchCategory, ResearchCategory } from '../../models/IResearchCategory';
import { IQuota } from '../../models/IQuota';
import { IQuotaTable } from '../../models/IQuotaTable';
import { ITarget } from '../../models/ITarget';
import { IQuestion } from '../../models/IQuestion';
import { ILanguage } from '../../models/ILanguage';
import { FezaDataService } from '../../services/fezadata.service';
import { IDefaultFactors } from '../../models/IDefaultFactors';
import { ITextItem } from '../../models/ITextItem';
import { IItem } from '../../models/IItem';
import { QuotaAllocationMode, QuotaAllocationModeList, QuotaAllocationModeByName, QuotaAllocationModeById } from '../../enums/quota-allocation-mode.enum';
import { FeasibilityCheckSupplierMode, FeasibilityCheckSupplierModeList, FeasibilityCheckSupplierModeByName, FeasibilityCheckSupplierModeById } from '../../enums/feasibility-check-supplier-mode.enum';

@Component({
    selector: 'feza-sample',
    templateUrl: './sample.component.html',
    styleUrls: ['./sample.component.css'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective }
    ]
})

export class SampleComponent implements OnInit, OnChanges {
    private form: FormGroup;
    @Input() sample: ISample;
    @Input('group') public formGroup: FormGroup;
    @Input() sampleIndex: number; 
    @Input() showDelete: boolean;
    @Input() correlationId: string;
    @Output() deleteSample: EventEmitter<number> = new EventEmitter();
    countryList$: Observable<Array<ICountry>>;
    languageList$: Observable<Array<ILanguage>>;
    sampleCategoryList$: Observable<Array<ISampleCategory>>;
    selectedCategory: ISampleCategory;
    researchTypeList$: Observable<Array<IItem>>;
    locales: Array<string> = [];
    showInternalDetails: boolean = false;
    showOtherSettings: boolean = false; 
    showTarget: boolean = false;
    showTrackerSettings: boolean = false;
    quotaAllocationItem: IItem;
    quotaAllocationModeList = QuotaAllocationModeList;
    feasibilityCheckSupplierModeItem: IItem;
    feasibilityCheckSupplierModeList = FeasibilityCheckSupplierModeList;

    constructor(private parent: FormGroupDirective,
        private fb: FormBuilder,
        private dataService: S1DataService,
        private fezaService: FezaDataService) {
    }

    ngOnInit() {
        this.sample = this.sample || new Sample();
        this.countryList$ = this.dataService.getCountries();
        this.sampleCategoryList$ = this.dataService.getSampleCategories();
        this.researchTypeList$ = this.dataService.getResearchTypes();
        this.sample.researchCategories.map((item, index) => {
            if (item.mainCategory)
                this.onResearchCategoryPicked([item.mainCategory, item.genericCategory, item.category, index.toString()], false);
        });
        this.form = this.parent.form;
    }

    ngOnChanges() {
        this.UpdateDuration();
        this.quotaAllocationItem = QuotaAllocationModeByName(this.sample.quotaAllocationMode);
        this.feasibilityCheckSupplierModeItem = FeasibilityCheckSupplierModeByName(this.sample.feasibilityCheckSupplierMode);
        this.dataService.getCountries().subscribe(countryList => {
            for (var country of countryList) {
                if (country.code.toLowerCase() == (this.sample.countryCode || "").toLowerCase())
                    this.onCountryPicked(country, this.formGroup.get('countryCode').value.toLowerCase() !== country.code.toLowerCase());
            }
        });
    }

    onDeleteSubsample() {
        this.deleteSample.emit(this.sample.id);
    }

    onResearchTypePicked() {
        this.sample.researchType = this.formGroup.get('researchType').value;
        this.getDefaultAbandonRate();
        this.getDefaultSniffoutRate();
    }

    onLOIChanged() {
        this.getDefaultAbandonRate();
    }

    onDeviceChanged() {
        this.getDefaultSniffoutRate();
    }

    onCountryPicked(country: ICountry, resetRates: boolean) {
        let newSelection: boolean = country.code.toLowerCase() !== (this.sample.countryCode || "").toLowerCase() || !this.sample.countryCultures;
        if (newSelection) {
            this.sample.countryCultures = this.locales = [];
            this.sample.countryCode = this.formGroup.get('countryCode').value;
        }
        this.languageList$ = this.dataService.getLanguages(country.id);
        if (newSelection) {
            const localeArray: FormArray = this.formGroup.get('countryCultures') as FormArray;
            var toDelete = new Array<number>();
            localeArray.controls.forEach((ctrl: FormControl, index: number) => { toDelete.push(index); });
            toDelete.sort().reverse().forEach(index => localeArray.removeAt(index));
            this.languageList$.subscribe(langs => {
                this.locales = Array.from(langs)
                    .sort((x, y) => (x.countryDefault === y.countryDefault) ? 0 : x.countryDefault ? -1 : 1)
                    .map(x => x.locale);
                this.sample.countryCultures = this.locales;
                this.locales.forEach((locale: string) => { localeArray.push(new FormControl(locale)); });
                if (resetRates) {
                    this.getDefaultAbandonRate();
                    this.getDefaultSniffoutRate();
                }
            });
        }
        if (resetRates) {
            this.getDefaultAbandonRate();
            this.getDefaultSniffoutRate();
        }
    }


    getDefaultAbandonRate() {
        let countryCode = this.formGroup.get('countryCode').value || "";
        let lengthOfInterview = this.formGroup.get('lengthOfInterview').value || "";
        let researchType = this.formGroup.get('researchType').value || "";
        let languages = this.getLanguageList();
        if (languages.length !== 0 && lengthOfInterview !== "" && researchType !== "") {
            this.fezaService.DefaultDropoutRate(countryCode, languages, lengthOfInterview, researchType).subscribe(rate => { this.formGroup.patchValue({ "abandonRatePercent": rate }); });
        }
    }

    getDefaultSniffoutRate() {
        let countryCode = this.formGroup.get('countryCode').value || "";
        let allowMobile = this.formGroup.get('allowMobile').value || false;
        let allowTablet = this.formGroup.get('allowTablet').value || false;
        let allowDesktop = this.formGroup.get('allowDesktop').value || false;
        let researchType = this.formGroup.get('researchType').value || "";
        let languages = this.getLanguageList();
        if (countryCode !== "" && languages.length !== 0) {
            this.fezaService.DefaultSniffoutRate(countryCode, researchType, languages, allowMobile, allowTablet, allowDesktop).subscribe(rate => { this.formGroup.patchValue({ "sniffoutRatePercent": rate }); });
        }
    }

    getLanguageList(): string[] {
        const localeArray: FormArray = this.formGroup.get('countryCultures') as FormArray;
        let languages = new Array<string>();
        localeArray.controls.forEach((ctrl: FormControl, index: number) => { languages.push(ctrl.value) });
        return languages;
    }

    onLanguageClicked(event) {
        const formArray: FormArray = this.formGroup.get('countryCultures') as FormArray;
        if (event.target.checked) {
            formArray.push(new FormControl(event.target.value));
        }
        else {
            formArray.controls.forEach((ctrl: FormControl, index: number) => {
                if (ctrl.value == event.target.value) {
                    formArray.removeAt(index);
                    return;
                }
            });
        }
        this.sample.countryCultures = this.getLanguageList();
        this.getDefaultAbandonRate();
        this.getDefaultSniffoutRate();
    }

    onCategoryAddButton(event) {
        const formArray: FormArray = this.formGroup.get('researchCategories') as FormArray;
        let newItem = new ResearchCategory();
        this.sample.researchCategories.push(newItem);
        formArray.push(new FormControl(newItem));
    }

    onResearchCategoryPicked(categories: Array<string>, newItem: boolean = true) {
        let formArray: FormArray = this.formGroup.get('researchCategories') as FormArray;
        let index = parseInt(categories[3]);
        let newCategory = new ResearchCategory(categories[0], categories[1], categories[2]);
        formArray.removeAt(index);
        formArray.insert(index, new FormControl(newCategory));
        if (newItem) {
            this.sample.researchCategories.splice(index, 1, newCategory);
        }
        this.sample.researchCategories = this.sample.researchCategories.slice(0);//change detection
    }

    onCategoryDeleteButton(event) {
        var formArray: FormArray = this.formGroup.get('researchCategories') as FormArray;
        formArray.removeAt(this.sample.researchCategories.length - 1);
        this.sample.researchCategories.pop();
        this.sample.researchCategories = this.sample.researchCategories.slice(0);//change detection
    }

    onDateSelected(event) {
        this.formGroup.patchValue({ "fieldStartDate": "" + event.year + "-" + event.month + "-" + event.day + "T00:00:00.000" });
    }

  onQuotasPicked(quotas: IQuotaTable[]) {
    this.sample.quotaTables = quotas;
    this.formGroup.patchValue({ "quotaTables": quotas });
  }

    onQuotaAllocationChanged(item: IItem) {
        this.sample.quotaAllocationMode = item.name;
        this.formGroup.patchValue({ "quotaAllocationMode": item.name });
    }

    onfeasibilityCheckSupplierChanged(item: IItem) {
        this.sample.feasibilityCheckSupplierMode = item.name;
        this.formGroup.patchValue({ "feasibilityCheckSupplierMode": item.name });
    }

    UpdateDuration() {
        var days: number = this.formGroup.get("_daysInField").value;
        var hours: number = this.formGroup.get("_hoursInField").value;
        this.formGroup.patchValue({ "hoursInField": hours + (days * 24) });
    }

    onSampleCategorySelected(category: number) {
        this.formGroup.patchValue({ "sampleSubCategoryId": null });
        this.sampleCategoryList$.subscribe(x => this.selectedCategory = x.find(x => x.categoryId == category));
    }

    getCategories(index: number) {
        return [this.sample.researchCategories[index].mainCategory,
        this.sample.researchCategories[index].genericCategory,
        this.sample.researchCategories[index].category];
    }

    isLangChecked(locale: string): string {
        for (var sampleLocale of this.sample.countryCultures) {
            if (sampleLocale.toLowerCase() === locale.toLowerCase())
                return "checked";
        }
        return null;
    }

    onCalculateMaxBlendChange(val: boolean) {
        //TODO: display this only if the conditions apply
        //this.formGroup.get('calculateMaxBlend').setValue(false);
        //console.log(this.formGroup.get('calculateMaxBlend').value);
        //if (this.sample.flexibleFieldDuration !== false || this.sample.quotaAllocationMode !== "Balanced") {
        //    this.sample.calculateMaxBlend = false;
        //    this.formGroup.patchValue({ "calculateMaxBlend": false });
        //}
    }

    setDefaultFactors(factors: IDefaultFactors) {
        this.formGroup.patchValue({ "eligibilityFactor": factors.eligibilityFactor });
    }

  onTargetChanged(target: ITarget[]) {
      this.sample.target = target;
      this.formGroup.patchValue({ "target": target });
    }

  onSampleCategoryChanged(sampleCategory: number) {
    this.sample.sampleCategoryId = sampleCategory;
    this.formGroup.patchValue({ "sampleCategoryId": sampleCategory });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sample/sample.component.ts